import React, { Component } from "react"
import PropsTypes from "prop-types"
import moment from "moment"
import ShareButtons from "../ShareButtons"

import "./articleHeader.scss"

class ArticleHeader extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { title, subtitle, createdBy, categories, slug } = this.props

    const publishDate = new Date(this.props.publishDate).toISOString()

    return (
      <header className="article-header">
        <h1
          className="article-header__title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <p
          className="article-header__subtitle"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
        <div className="article-header__createdby">
          <div className="article-header__lede">
            {categories && (
              <span className="article-header--link">{categories}</span>
            )}
            <span
              className="article-header--link"
              dangerouslySetInnerHTML={{ __html: createdBy }}
            />
            <span> | </span>
            <span>{moment(publishDate).format("MMMM DD, YYYY")}</span>
          </div>
          <ShareButtons
            {...this.props}
            articleSlug={slug[0]}
            title={title}
            message="Check out this post!"
          />
        </div>
      </header>
    )
  }
}

ArticleHeader.propTypes = {
  title: PropsTypes.string,
  subtitle: PropsTypes.string,
  createdBy: PropsTypes.string,
  categories: PropsTypes.arrayOf(PropsTypes.string),
  publishDate: PropsTypes.string,
  leadimage: PropsTypes.object,
  headerImage: PropsTypes.object,
}

export default ArticleHeader
